const palette = {
  white: '#fff',
  black: '#000',
  primary: {
    main: '#628bf5',
    light: '#cedfff',
    light2: '#eaf1ff',
    light3: '#f5f9ff',
    light4: 'rgb(245 249 255 / 50%)',
    medium: '#8babff',
    medium2: '#C4D4FE',
    medium3: '#758ecb',
    dark: '#004581',
    dark2: '#4954cc',
  },
  secondary: {
    dark: '#149488',
    main: '#1ac1b1',
    light: '#c9efec',
    light2: '#d9f3f1',
  },
  tertiary: {
    dark: '#a86bda',
    main: '#cca8e9',
    light: '#eadbf6',
    light2: '#f0e5f8',
  },
  error: {
    dark: '#c62828',
    main: '#d32f2f',
    light: '#ef5350',
    light2: '#ffcccb',
    light3: '#fce8e6',
  },
  success: {
    dark: '#1b5e20',
    main: '#2e7d32',
    light: '#4caf50',
    light2: '#d2f8d2',
    light3: '#e6f4ea',
  },
  warning: {
    dark: '#e65100',
    main: '#ed6c02',
    light: '#ff9800',
    light2: '#ffdcb4',
    light3: '#fff4e7',
  },
  text: {
    primary: '#2F2F2F',
    secondary: '#5B5B5B',
  },
  boxShadow: {
    type0: 'none',
    type1: 'rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px',
    type2: '0px 4px 18px rgba(0, 0, 0, 0.05)',
    type3: '0 4px 12px 0 rgba(0, 0, 0, 0.25)',
    type4: '0 3px 15px 0 rgba(47, 47, 47, 0.12)',
    type5: '0 1px 6px 0 rgb(109 109 109 / 14%)',
    type6: '0 1px 2px 0 rgb(109 109 109 / 14%)',
    button: '0 3px 6px 0 #a5beff',
    chip: '0 1px 3px 0 #1ac1b1',
    chip2: '0 1px 3px 0 #cca8e9',
  },
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161',
  },
};

export default palette;
